import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, inject, signal, input, linkedSignal } from '@angular/core';
import {Project} from '@app/modules/shared/models';
import { FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {
  getProjectError,
  IProjectState,
  ProjectList,
  ResetProjectState,
  getPaginatedProjects,
  ProjectGet, getProject
} from '@app/stores';
import {select, Store} from '@ngrx/store';
import {takeUntil} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';
import {Subject} from 'rxjs';
import { SbInputFormComponent } from '../../../_components/unified/sb-form/sb-form.component';
import { AutoCompleteSelectComponent } from '../../../_components/auto-complete-select/auto-complete-select.component';

@Component({
  selector: 'app-campaign-copy',
  templateUrl: './campaign-copy.component.html',
  styleUrls: ['./campaign-copy.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SbInputFormComponent, ReactiveFormsModule, AutoCompleteSelectComponent]
})
export class CampaignCopyComponent implements OnInit, OnDestroy {
  modal = inject(NgbActiveModal);
  fb = inject(FormBuilder);
  private projectStore = inject<Store<IProjectState>>(Store);
  private toastr = inject(ToastrService);


  public campaignForm: FormGroup<{
    name: FormControl<string | null>;
    project_id: FormControl<number | null>;
    with_influencers: FormControl<boolean | null>;
  }>;
  submitted = false;
  unsubscriber = new Subject();
  public readonly projects = signal<Project[]>([]);
  public projectByClient: any = [];
  readonly projectIdInput = input<number>(undefined, {alias: 'projectId'});
  readonly projectId = linkedSignal(() => this.projectIdInput());
  selectedProject: any;

  constructor() {
    this.projectStore.dispatch(ResetProjectState({params: {error: '', projects: []}}));
  }

  get f() {
    return this.campaignForm.controls;
  }

  subscribeStores() {
    this.projectStore.pipe(select(getProjectError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.toastr.error(error, 'Error');
        }
      });

    this.projectStore.pipe(select(getProject))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(project => {
        if (project) {
          this.selectedProject = project;
        }
      });
    this.projectStore.pipe(select(getProjectError))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(error => {
        if (error) {
          this.toastr.error(error);
        }
      });
    this.projectStore.pipe(select(getPaginatedProjects))
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(paginatedProjects => {
        if (paginatedProjects) {
          let projects = paginatedProjects.list;
          const projectIds = projects.map(item => item.id);
          if (this.selectedProject && !projectIds.includes(this.selectedProject.id)) {
            projects = [...projects, this.selectedProject];
          }
          this.projects.set(projects.map(project => ({
            ...project,
            title: `${project?.client?.name} - ${project?.title}`
          })));
          // this.groupProjects();
        }
      }
      );
  }

  ngOnInit(): void {
    const projectId = this.projectId();
    if (projectId) {
      this.projectStore.dispatch(ProjectGet({projectId: projectId}));
    }
    this.loadAllProjects();
    this.subscribeStores();
    this.campaignForm = this.fb.group({
      name: ['', [Validators.required]],
      project_id: [projectId, [Validators.required]],
      with_influencers: [true],
    });
  }

  saveProject() {
    this.submitted = true;
    if (this.campaignForm.invalid) {
      return;
    }
    this.modal.close(this.campaignForm.value);
  }

  handleSearchValue(searchTerm) {
    this.loadAllProjects(searchTerm.term);
  }

  handleProjectSelection(selectedProject: any) {
    if (selectedProject && selectedProject.value) {
      this.campaignForm.get('project_id')?.setValue(selectedProject.value);
    } else {
      this.loadAllProjects();
      this.campaignForm.get('project_id')?.setValue(null);
    }
  }

  ngOnDestroy() {
    this.unsubscriber.next(undefined);
    this.unsubscriber.complete();
  }

  loadAllProjects(search = '', page = 1, perPage = 10, orderBy= {column: 'created_at', dir: 'desc'}, fields = ['id', 'title', 'created_at'], clientFields = ['id', 'name']) {
    const option: any = {includePagination: true, orderBy, fields};
    this.projectStore.dispatch(ProjectList({
      params: {
        options: JSON.stringify(option),
        page,
        perPage,
        search,
      }
    }));
  }

}
